import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "react-bootstrap";
import { translate } from "react-switch-lang";

function TargetCard({
  t,
  targetValue,
  targetOpen,
  setTargetOpen,
  onCardChange,
}) {
  const toggleItem = (item) => {
    const isSelected = targetValue.includes(item);
    const updated = isSelected
      ? targetValue.filter((i) => i !== item)
      : [...targetValue, item];
    onCardChange(updated);
  };

  const targets = [
    t("targets.Low-income"),
    t("targets.Unemployed"),
    t("targets.Families Encountering Sudden Change"),
    t("targets.Street Sleepers"),
    t("targets.Elderly"),
    t("targets.Disability"),
    t("targets.CSSA Recipients"),
    t("targets.School Textbook Allowance Recipients"),
  ];

  const renderTitle = () => {
    if (targetValue.length === 0) return `👥 ${t("targets.Placeholder")}`;
    if (targetValue.length === 1) return `👥 ${targetValue[0]}`;
    return `👥 已選 ${targetValue.length}`;
  };

  return (
    <Dropdown
      drop="down"
      className="filter-pill w-100"
      show={targetOpen}
      onToggle={(isOpen) => setTargetOpen(isOpen)}
    >
      <Dropdown.Toggle
        variant="light"
        className="dropdown-toggle-pill w-100 text-start"
      >
        {renderTitle()}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {targets.map((target) => (
          <Dropdown.Item
            key={target}
            as="button"
            className="d-flex align-items-center"
            onClick={() => {
              toggleItem(target);
            }}
          >
            <input
              type="checkbox"
              className="me-2"
              readOnly
              checked={targetValue.includes(target)}
            />
            {target}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

TargetCard.propTypes = {
  t: PropTypes.func.isRequired,
  targetValue: PropTypes.array.isRequired,
  targetOpen: PropTypes.bool.isRequired,
  setTargetOpen: PropTypes.func.isRequired,
  onCardChange: PropTypes.func.isRequired,
};

const TranslateTargetCard = translate(TargetCard);
export default TranslateTargetCard;
